/* Override current typography or define any new typography here.
 * e.g typographyLiterals.body2 = css``
 */

import * as DwTypographyLiterals from '@dreamworld/material-styles/typography-literals.js';

export const typographyLiterals = DwTypographyLiterals;

export default typographyLiterals;